import { render, staticRenderFns } from "./ContactFresh.vue?vue&type=template&id=d8576eb4&"
import script from "./ContactFresh.vue?vue&type=script&lang=js&"
export * from "./ContactFresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports